<template>
  <div v-if="showMenu" class="footer-menu">
    <NuxtLink v-if="showProductsLink" to="/products" class="fa btn-plugins footer-fa">
      <span>Products</span>
    </NuxtLink>
    <NuxtLink v-if="showDownloadsLink" to="/downloads" class="fa btn-download footer-fa">
      <span>Downloads</span>
    </NuxtLink>
    <NuxtLink v-if="showShopLink" to="/shop" class="fa btn-shop fa-shopping-cart footer-fa">
      <span>Shop</span>
    </NuxtLink>
    <NuxtLink v-if="showSupportLink" to="/support" class="fa btn-support footer-fa">
      <span>Support</span>
    </NuxtLink>
    <NuxtLink v-if="showAccountLink && !allLinksVisible" to="/account" class="fa fa-user footer-fa">
      <span>Account</span>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const showProductsLink = computed(() => route.path !== '/products');
const showDownloadsLink = computed(() => route.path !== '/downloads');
const showShopLink = computed(() => route.path !== '/shop');
const showSupportLink = computed(() => route.path !== '/support');
const showAccountLink = computed(() => route.path !== '/account');

const showMenu = computed(() => !route.path.includes('/products/'));

// Check if all links are visible
const allLinksVisible = computed(() => {
  return showProductsLink.value && showDownloadsLink.value && showShopLink.value && showSupportLink.value;
});
</script>


<style scoped lang="scss">
@import '~/assets/constants.scss';

.btn-plugins:before
{
  content: "\f1b3";
}

.btn-shop:before
{
  content: "\f54f";
}

.btn-download:before
{
  content: "\f019";
}

.btn-support:before
{
  content: "\f128";
}

</style>
